// import React from "react";
// import { MDBBtn, MDBCheckbox } from "mdb-react-ui-kit";

// const ImageProcessingStep = ({
//   formData,
//   processing,
//   processingImages,
//   progress,
//   processedImages,
//   handleInputChange,
//   handleStartImageEditing,
// }) => {
//   return (
//     <div className="step-panel">
//       <div className="step-header">
//         <h2>Image Processing</h2>
//         <p>Select enhancements to apply to your images</p>
//       </div>
//       <div className="image-options">
//         <div className="checkbox-wrapper">
//           <MDBCheckbox
//             label="Background Removal"
//             checked={formData.backgroundRemoval}
//             onChange={(e) =>
//               handleInputChange("backgroundRemoval", e.target.checked)
//             }
//           />
//         </div>
//         <div className="checkbox-wrapper">
//           <MDBCheckbox
//             label="Upscale Image"
//             checked={formData.upscaleImage}
//             onChange={(e) => handleInputChange("upscaleImage", e.target.checked)}
//           />
//         </div>
//       </div>
//       <MDBBtn
//         className="mt-3"
//         disabled={processing}
//         onClick={handleStartImageEditing}
//       >
//         {processing ? "Processing..." : "Start Image Processing"}
//       </MDBBtn>
//       {processingImages && (
//         <div className="progress-bar-wrapper mt-3">
//           <div className="progress-bar-bg">
//             <div
//               className="progress-bar-fill"
//               style={{ width: `${progress}%` }}
//             />
//           </div>
//           <span>{progress}% Processing</span>
//         </div>
//       )}
//       {processedImages.length > 0 && (
//         <div className="processed-images mt-4">
//           {processedImages.map((img, i) => (
//             <img key={i} src={img} alt={`Processed ${i}`} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageProcessingStep;

import React, { useState } from "react";
import { MDBBtn, MDBCheckbox } from "mdb-react-ui-kit";
import { FaRedo } from "react-icons/fa";
import "./ImageProcessingStep.css";

const ImageProcessingStep = ({
  formData,
  processing,
  processingImages,
  progress,
  processedImages,
  handleSwapImages,
  handleInputChange,
  handleStartImageEditing,
}) => {
  const [rotations, setRotations] = useState({});
  const [selected, setSelected] = useState([]);

  // Rotate
  const handleRotate = (index) => {
    setRotations((prev) => ({
      ...prev,
      [index]: (prev[index] || 0) + 90,
    }));
  };

  // Select image
  const handleSelect = (index) => {
    let newSelected = [...selected];

    if (newSelected.includes(index)) {
      newSelected = newSelected.filter((i) => i !== index);
    } else {
      if (newSelected.length === 2) newSelected.shift(); // keep only two
      newSelected.push(index);
    }

    setSelected(newSelected);
  };

  // Swap images
  const handleSwap = () => {
    if (selected.length !== 2) return;

    const [first, second] = selected;

    handleSwapImages(first, second);
    setSelected([]);
  };

  return (
    <div className="step-panel">
      <div className="step-header">
        <h2>Image Processing</h2>
        <p>Select enhancements to apply to your images</p>
      </div>

      <div className="image-options">
        <MDBCheckbox
          label="Background Removal"
          checked={formData.backgroundRemoval}
          onChange={(e) =>
            handleInputChange("backgroundRemoval", e.target.checked)
          }
        />

        <MDBCheckbox
          label="Upscale Image"
          checked={formData.upscaleImage}
          onChange={(e) => handleInputChange("upscaleImage", e.target.checked)}
        />
      </div>

      <MDBBtn
        className="mt-3"
        disabled={processing}
        onClick={handleStartImageEditing}
      >
        {processing ? "Processing..." : "Start Image Processing"}
      </MDBBtn>

      {processingImages && (
        <div className="progress-bar-wrapper mt-3">
          <div className="progress-bar-bg">
            <div
              className="progress-bar-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span>{progress}% Processing</span>
        </div>
      )}

      {processedImages.length > 0 && (
        <div className="image-grid mt-4">
          {processedImages.map((img, index) => (
            <div
              key={index}
              className={`image-item ${
                selected.includes(index) ? "selected" : ""
              }`}
              onClick={() => handleSelect(index)}
            >
              <img
                src={img}
                alt=""
                className="image-thumb"
                style={{
                  transform: `rotate(${rotations[index] || 0}deg)`,
                }}
              />

              {/* rotate */}
              <button
                className="rotate-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRotate(index);
                }}
              >
                <FaRedo size={14} />
              </button>
            </div>
          ))}
        </div>
      )}

      {selected.length === 2 && (
        <MDBBtn className="mt-3" onClick={handleSwap}>
          Swap Selected Images
        </MDBBtn>
      )}
    </div>
  );
};

export default ImageProcessingStep;
